export default {"src":"/_next/static/media/login.99dd0eb3.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};